import { interfaces } from "inversify";
import Container = interfaces.Container;
import SystemConfig, { CONFIG_PARAMS, MODES } from "../system/SystemConfig";
import SERVICE_IDENTIFIER from "../constants/identifiers";
import Regulation, { LEGISLATION } from "./Regulation";
import IRegulation from "./IRegulation";
import CzRegulation from "./CzRegulation";
import MtRegulation from "./MtRegulation";

export function createRegulation(container: Container) {
  defineRegulation(container);
  return container.get<IRegulation>(SERVICE_IDENTIFIER.Regulation);
}

function defineRegulation(container: Container) {
  let config = container.get<SystemConfig>(SERVICE_IDENTIFIER.SystemConfig);

  let reg = config.get(CONFIG_PARAMS.REGULATION);
  let leg = config.get(CONFIG_PARAMS.LEGISLATION);

  if (config.get(CONFIG_PARAMS.MODE) == MODES.REAL) {
    if (reg == LEGISLATION.CZ || leg == LEGISLATION.CZ) {
      container
        .bind<IRegulation>(SERVICE_IDENTIFIER.Regulation)
        .to(CzRegulation);
      return;
    }

    if (reg == LEGISLATION.MT || leg == LEGISLATION.MT) {
      container
        .bind<IRegulation>(SERVICE_IDENTIFIER.Regulation)
        .to(MtRegulation);
      return;
    }
  }

  container.bind<IRegulation>(SERVICE_IDENTIFIER.Regulation).to(Regulation);
}
